import { RefObject, useMemo, useRef } from 'react';
import { mixpanel } from '@fiverr-private/obs';
import { useAnalyticAdapter } from '../analyticAdapter';
import { BIMeta } from '../types';

export const useVideoMixpanelEvents = (videoRef: RefObject<HTMLVideoElement>, meta: BIMeta) => {
    const BIMeta = useRef(meta);
    const callbacks = useMemo(() => {
        const sendEvent = (eventName, props) => {
            const { videoName, pageName } = BIMeta.current;

            const base = {
                'Page name': pageName,
                'Video name': videoName,
            };

            return mixpanel.track(eventName, {
                ...base,
                ...props,
            });
        };

        const onPlay = () => {
            const { autoPlay, subtitleExist, subtitleLocale } = BIMeta.current;

            sendEvent('Video - Play', {
                'Auto play': autoPlay,
                'Subtitles exist': subtitleExist,
                'Subtitles language': subtitleLocale,
            });
        };

        const onWatched = () => {
            const { subtitleExist, subtitleLocale } = BIMeta.current;
            const { duration, currentTime } = videoRef.current || {};

            sendEvent('Video - Finished Watching', {
                'Watch duration': currentTime,
                'Video completed': duration === currentTime,
                'Subtitles exist': subtitleExist,
                'Subtitles language': subtitleLocale,
            });
        };

        const onSubtitleChange = (locale) => {
            const { subtitleLocale } = BIMeta.current;

            sendEvent('Video - changed subtitles language', {
                'Subtitles language': locale,
                'Subtitles previous language': subtitleLocale,
            });
        };

        return {
            onPlay,
            onWatched,
            onSubtitleChange,
        };
    }, [videoRef, BIMeta]);

    useAnalyticAdapter(videoRef, callbacks);
};
